<style scoped lang="stylus" rel="stylesheet/stylus">
.video-previewer
  width 109px
  height 109px
  .poster-box
    position relative
    width 100%
    height 100%
    &:before
      content ''
      position absolute
      left 0
      top 0
      width 100%
      height 100%
      border inherit
      border-color #000
      border-radius inherit
      background #000
      opacity 0.1
    .control
      font-size 32px
      color #fff
      position absolute
      left 50%
      top 50%
      transform translate(-50%, -50%)
    .poster
      width 100%
      height 100%
      object-fit cover
</style>

<template>
	<div class="video-previewer">
		<div class="flex-row-cen-cen poster-box" @click="openVideo">
			<div v-if="isVideoShow" class="control adv-pause"></div>
			<div v-else class="control adv-play"></div>
			<img class="poster" :src="poster" />
		</div>
		<van-popup v-model="isVideoShow" :style="{ width: '100%' }" get-container="#app">
			<video-player
				class="video-player vjs-custom-skin"
				ref="videoPlayer"
				:playsinline="true"
				@pause="onPlayerPause($event)"
				@canplaythrough="onPlayerCanplaythrough($event)"
				:options="playerOptions"
			>
			</video-player>
		</van-popup>
	</div>
</template>

<script>
import { videoPlayer } from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
export default {
	name: 'video-previewer',
	inject: ['videoPoster'],
	model: {},
	props: {
		src: {
			// 视频地址
			type: String,
			default: ''
		},
		poster: {
			// 封面地址
			type: String,
			default: ''
		}
	},
	components: {
		videoPlayer
	},
	data() {
		return {
			//      poster: '', // 封面地址
			inputKey: this.$common.getTimeStampId16(),
			isVideoShow: false, // 是否显示视频弹窗
			playerOptions: {
				// 播放选项
				playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
				autoplay: true, // 如果为true,浏览器准备好时开始回放。
				muted: false, // 默认情况下将会消除任何音频。
				loop: false, // 是否视频一结束就重新开始。
				preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
				language: 'zh-CN',
				aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
				fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
				sources: [
					{
						type: 'video/mp4', // 类型
						src: '' // url地址
					}
				],
				poster: '', // 封面地址
				notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
				controlBar: {
					timeDivider: true, // 当前时间和持续时间的分隔符
					durationDisplay: true, // 显示持续时间
					remainingTimeDisplay: false, // 是否显示剩余时间功能
					fullscreenToggle: true // 是否显示全屏按钮
				}
			}
		}
	},
	computed: {},
	mounted() {},
	watch: {
		isVideoShow(newVal, oldVal) {
			if (!newVal) {
				this.$refs.videoPlayer && this.$refs.videoPlayer.player && this.$refs.videoPlayer.player.pause() // 暂停
			}
		}
	},
	methods: {
		// 打开视频
		openVideo() {
			// this.playerOptions.sources[0].type = video.type
			this.playerOptions.sources[0].src = this.src
			//      console.log(this.playerOptions.sources[0])
			this.isVideoShow = true
			this.$refs.videoPlayer && this.$refs.videoPlayer.player && this.$refs.videoPlayer.player.play()
		},
		// 暂停回调
		onPlayerPause(player) {},
		// 加载完后执行
		onPlayerCanplaythrough() {
			this.$refs.videoPlayer && this.$refs.videoPlayer.player && this.$refs.videoPlayer.player.play()
		}
	}
}
</script>
